/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_Attach_WebInputs */

const en_pc_online_cmp_attach_web = /** @type {(inputs: Pc_Online_Cmp_Attach_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not in the browser yet`)
};

const zh_pc_online_cmp_attach_web = /** @type {(inputs: Pc_Online_Cmp_Attach_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器中暂不支持`)
};

/**
* | output |
* | --- |
* | "Not in the browser yet" |
*
* @param {Pc_Online_Cmp_Attach_WebInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_attach_web = /** @type {((inputs?: Pc_Online_Cmp_Attach_WebInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Attach_WebInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_attach_web(inputs)
	return zh_pc_online_cmp_attach_web(inputs)
});
export { pc_online_cmp_attach_web as "pc.online.cmp.attach.web" }